<div id="thankyou-container" class="thankyou-container">
      
      
        <div>            
           <h1>Thank you for taking part in the survey.
               <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg>
           </h1>
        </div>
    
  </div>
  